var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pro-icon-info"},[_c('div',{staticClass:"info-body"},[_c('p',[_vm._v(_vm._s(_vm.title ? _vm.title : _vm.$t('Информация о блоке')))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }